import { TaxiAchievementApiTaxiAchievementUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiAchievementUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiAchievementApiTaxiAchievementUpdateRequest, config) =>
      appApiClient.taxiAchievementApi.taxiAchievementUpdate(req, config),
  });
